import i18next from 'i18next';
export const loginTypes = {
    ANONYMOUSLOGIN: 0,
    FACEBOOKLOGIN: 1,
    LINELOGIN: 2,
    ENTERPRISELOGIN: 3,
    DEPRECATED_CODE_VALIDATION_LOGIN: 4,
    INSTAGRAM: 5
};

export const loginMethods = {
    FACEBOOK: 'facebook',
    LINE: 'line',
    ENTERPRISE: 'enterprise',
    INSTAGRAM: 'instagram'
};

export const loginMethodLabel = {
    [loginTypes.ANONYMOUSLOGIN]: 'label.no_login',
    [loginTypes.FACEBOOKLOGIN]: 'label.signin.facebook',
    [loginTypes.LINELOGIN]: 'label.signin.line',
    [loginTypes.ENTERPRISELOGIN]: 'label.signin.enterprise'
};

export const loginTypeToLoginMethod = {
    [loginTypes.ANONYMOUSLOGIN]: loginMethods.ANONYMOUS,
    [loginTypes.FACEBOOKLOGIN]: loginMethods.FACEBOOK,
    [loginTypes.LINELOGIN]: loginMethods.LINE,
    [loginTypes.ENTERPRISELOGIN]: loginMethods.ENTERPRISE
};

export const rewardsRoutesParamMappingLoginMethod = {
    line: loginTypes.LINELOGIN,
    facebook: loginTypes.FACEBOOKLOGIN,
    member: loginTypes.ENTERPRISELOGIN
};

export const rewardsRoutesParamMappingLoginType = {
    line: loginMethods.LINE,
    facebook: loginMethods.FACEBOOK,
    member: loginMethods.ENTERPRISE
};

export const loginTypesForApi = {
    ANONYMOUS: 'anonymous',
    FACEBOOK: 'facebook',
    LINE: 'line',
    ENTERPRISE: 'enterprise',
    INSTAGRAM: 'instagram'
};

export const loginTypesForLiff = {
    LIFF_TOKEN: 'liff_token',
    LIFF_TOKEN_ENTERPRISE: 'liff_token_enterprise'
};

export const loginButtonText = {
    [loginMethods.FACEBOOK]: i18next.t('label.use.facebook.account.login'),
    [loginMethods.LINE]: i18next.t('label.use.line.account.login'),
    [loginMethods.ENTERPRISE]: i18next.t('label.login.enterprise')
};

export const loginTypeMappingPointRoutesParam = {
    [loginTypes.FACEBOOKLOGIN]: [loginMethods.FACEBOOK],
    [loginTypes.LINELOGIN]: [loginMethods.LINE],
    [loginTypes.ENTERPRISELOGIN]: [loginMethods.ENTERPRISE]
};

export const loginMethodMappingLoginTypeForApi = {
    [loginTypes.ANONYMOUSLOGIN]: loginTypesForApi.ANONYMOUS,
    [loginTypes.FACEBOOKLOGIN]: loginTypesForApi.FACEBOOK,
    [loginTypes.LINELOGIN]: loginTypesForApi.LINE,
    [loginTypes.ENTERPRISELOGIN]: loginTypesForApi.ENTERPRISE
};

export const typeError = {
    LOGIN_TYPE_NOT_SET: 'login_type_not_set',
    MEMBER_LEVEL_TYPE_NOT_SET: 'member_level_type_not_set',
    ACHIEVEMENT_LEVEL_NOT_SET: 'achievement_level_not_set'
};
